// extracted by mini-css-extract-plugin
export default {"threedotsBtn":"style_threedotsBtn__TKl3T","container":"style_container__s8jwN"};